module.exports = __webpack_public_path__ + "static/media/ertec1.13d9651d.jpg";